// 자막 이름표(북마크 탭) 스타일 프리셋 SSOT — 런타임(OverlayItem)·기즈모(OverlayGizmo)·인스펙터 공유.
//  선택값은 clip.style.nameTagPreset(cmds argSchema2.style로 저장). 기본 = plain(배경 없이 텍스트만).
export const NAME_TAG_PRESETS = [
  {
    key: "plain",
    label: "기본 (텍스트만)",
    style: { background: "transparent", color: "#fff", padding: "2px 2px", borderRadius: "0", textShadow: "0 1px 3px rgba(0, 0, 0, 0.8)" },
  },
  {
    key: "band",
    label: "블랙 탭",
    style: { background: "rgba(0, 0, 0, 0.6)", color: "#fff", padding: "2px 10px", borderRadius: "6px 6px 0 0" },
  },
  {
    key: "purple",
    label: "퍼플 탭",
    style: { background: "#9155fd", color: "#fff", padding: "2px 10px", borderRadius: "6px 6px 0 0" },
  },
  {
    key: "white",
    label: "화이트 탭",
    style: { background: "rgba(255, 255, 255, 0.92)", color: "#222", padding: "2px 10px", borderRadius: "6px 6px 0 0" },
  },
  {
    key: "outline",
    label: "아웃라인",
    style: { background: "transparent", color: "#fff", padding: "1px 9px", borderRadius: "6px 6px 0 0", border: "1.5px solid rgba(255, 255, 255, 0.85)", textShadow: "0 1px 3px rgba(0, 0, 0, 0.6)" },
  },
  {
    key: "none",
    label: "없음",
    style: { display: "none" }, // 이름표 숨김 — 런타임/기즈모 공용(프리셋 스타일로 처리)
  },
];

export function nameTagPresetStyle(key) {
  const p = NAME_TAG_PRESETS.find((x) => x.key === key) || NAME_TAG_PRESETS[0]; // 기본 plain
  return { ...p.style };
}
